import { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useConsumerAuth } from '../context/ConsumerAuthContext.jsx';

function Signup() {
  const { signup } = useConsumerAuth();
  const [form, setForm] = useState({
    name: '',
    email: '',
    password: '',
    location: '',
    zip: '',
    preferredBin: '',
  });
  const [error, setError] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const navigate = useNavigate();

  const handleChange = (event) => {
    const { name, value } = event.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    setError('');
    if (!form.name || !form.email || !form.zip || !form.password) {
      setError('Name, email, password, and ZIP code are required');
      return;
    }
    try {
      setSubmitting(true);
      await signup(form);
      navigate('/my-impact');
    } catch (err) {
      console.error('Signup failed', err);
      setError(err?.message || 'Sign up failed. Please try again.');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="space-y-6">
      <header className="space-y-2">
        <h1 className="text-3xl font-semibold text-primary">Create a Pact account</h1>
        <p className="text-sm text-neutral">
          Save your preferred bin locations and see impact stats once the dashboard launches.
        </p>
      </header>
      <form onSubmit={handleSubmit} className="card bg-base-100 shadow-lg">
        <div className="card-body space-y-5">
          <div className="grid gap-4 sm:grid-cols-2">
            <div className="form-control sm:col-span-2">
              <label className="label" htmlFor="name">
                <span className="label-text uppercase tracking-[0.14em] text-neutral">Name</span>
              </label>
              <input
                id="name"
                name="name"
                className="input input-bordered rounded-xl"
                value={form.name}
                onChange={handleChange}
                required
              />
            </div>
            <div className="form-control">
              <label className="label" htmlFor="email">
                <span className="label-text uppercase tracking-[0.14em] text-neutral">Email</span>
              </label>
              <input
                id="email"
                name="email"
                type="email"
                className="input input-bordered rounded-xl"
                value={form.email}
                onChange={handleChange}
                required
              />
            </div>
            <div className="form-control">
              <label className="label" htmlFor="password">
                <span className="label-text uppercase tracking-[0.14em] text-neutral">Password</span>
              </label>
              <input
                id="password"
                name="password"
                type="password"
                className="input input-bordered rounded-xl"
                value={form.password}
                onChange={handleChange}
                placeholder="••••••••"
                required
              />
            </div>
            <div className="form-control">
              <label className="label" htmlFor="location">
                <span className="label-text uppercase tracking-[0.14em] text-neutral">City / State</span>
              </label>
              <input
                id="location"
                name="location"
                className="input input-bordered rounded-xl"
                value={form.location}
                onChange={handleChange}
                placeholder="e.g. Brooklyn, NY"
              />
            </div>
            <div className="form-control">
              <label className="label" htmlFor="zip">
                <span className="label-text uppercase tracking-[0.14em] text-neutral">ZIP code</span>
              </label>
              <input
                id="zip"
                name="zip"
                className="input input-bordered rounded-xl"
                value={form.zip}
                onChange={handleChange}
                required
              />
            </div>
            <div className="form-control sm:col-span-2">
              <label className="label" htmlFor="preferredBin">
                <span className="label-text uppercase tracking-[0.14em] text-neutral">
                  Preferred bin location (optional)
                </span>
              </label>
              <input
                id="preferredBin"
                name="preferredBin"
                className="input input-bordered rounded-xl"
                value={form.preferredBin}
                onChange={handleChange}
                placeholder="Store or neighborhood"
              />
            </div>
          </div>
          {error ? (
            <div className="alert alert-error text-sm">
              <span>{error}</span>
            </div>
          ) : null}
          <button type="submit" className="btn btn-primary w-full rounded-full" disabled={submitting}>
            {submitting ? 'Creating account…' : 'Create account'}
          </button>
          <p className="text-xs text-neutral">
            Already have an account?{' '}
            <Link to="/login" className="link link-primary">
              Log in
            </Link>
            .
          </p>
        </div>
      </form>
    </div>
  );
}

export default Signup;
